// Mirror of the backend EXPORT_EMAIL_ALLOWLIST in /app/backend/server.py.
// Changes here are cosmetic — they hide the Export button in the UI for
// non-allowlisted users. The backend enforces the real gate. Keep this
// list in sync with the backend constant.
const EXPORT_EMAIL_ALLOWLIST = new Set([
  "speakguru@gmail.com",
  "guruv.finance@gmail.com",
  "support@humanebehavior.com",
  "admin@humanebehavior.com",
  "test1@humanebehavior.com",
  "vasanth3981@gmail.com",
]);

export function canExport(user) {
  if (!user || typeof user !== "object") return false;
  const email = (user.email || "").toLowerCase().trim();
  return EXPORT_EMAIL_ALLOWLIST.has(email);
}
